import { useCallback } from "react";
import ExportDataAthleteForm from "../../../../components/Forms/ExportDataAthleteForm";
import { useExportAthletes } from "../../../../hooks";
import useAthleteStore from "providers/AthletesProvider/useAthleteStore";
import useGroupsContext from "hooks/useGroupsContext";
import useExercises from "providers/ExercisesProvider/useExercises";
import useGetAllCircuitsQuery from "hooks/useGetAllCircuitsQuery";
import useCanDo from "hooks/useCanDo";
import { circuitsEnabled } from "config/features";

function ExportAthleteData() {
  const athletes = useAthleteStore();
  const [groups] = useGroupsContext();
  const exportAthletes = useExportAthletes();
  const exercises = useExercises();
  // Circuits reuse the custom-exercise policy and the build flag, matching MetadataProvider.
  const canAccessCircuits = useCanDo("library.any");
  const { data: circuits } = useGetAllCircuitsQuery({ enabled: circuitsEnabled && canAccessCircuits });

  const handleSubmit = useCallback((values: any) => exportAthletes(values), [exportAthletes]);

  return (
    <ExportDataAthleteForm
      onSubmit={handleSubmit}
      athletes={athletes}
      groups={groups}
      exercises={exercises}
      circuits={circuits}
    />
  );
}
export default ExportAthleteData;
